var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStopwatch(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_10_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18 13C18 11.4087 17.3674 9.88303 16.2422 8.75781C15.117 7.63259 13.5913 7 12 7C10.4087 7 8.88303 7.63259 7.75781 8.75781C6.63259 9.88303 6 11.4087 6 13C6 13.7879 6.15552 14.568 6.45703 15.2959C6.75856 16.0239 7.20066 16.685 7.75781 17.2422C8.31496 17.7993 8.97615 18.2414 9.7041 18.543C10.432 18.8445 11.2121 19 12 19C12.7879 19 13.568 18.8445 14.2959 18.543C15.0239 18.2414 15.685 17.7993 16.2422 17.2422C16.7993 16.685 17.2414 16.0239 17.543 15.2959C17.8445 14.568 18 13.7879 18 13ZM20 13C20 14.0506 19.7927 15.0909 19.3906 16.0615C18.9886 17.0321 18.4 17.9144 17.6572 18.6572C16.9144 19.4 16.0321 19.9886 15.0615 20.3906C14.0909 20.7927 13.0506 21 12 21C10.9494 21 9.90908 20.7927 8.93848 20.3906C7.96795 19.9886 7.08559 19.4 6.34277 18.6572C5.59995 17.9144 5.01141 17.0321 4.60938 16.0615C4.20734 15.0909 4 14.0506 4 13C4 10.8783 4.84248 8.84306 6.34277 7.34277C7.84306 5.84248 9.87827 5 12 5C14.1217 5 16.1569 5.84248 17.6572 7.34277C19.1575 8.84306 20 10.8783 20 13Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.793 9.79297C14.1835 9.40245 14.8165 9.40245 15.207 9.79297C15.5976 10.1835 15.5976 10.8165 15.207 11.207L12.707 13.707C12.3165 14.0976 11.6835 14.0976 11.293 13.707C10.9024 13.3165 10.9024 12.6835 11.293 12.293L13.793 9.79297Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.293 6.29297C17.6835 5.90245 18.3165 5.90245 18.707 6.29297C19.0976 6.68349 19.0976 7.31651 18.707 7.70703L17.707 8.70703C17.3165 9.09756 16.6835 9.09756 16.293 8.70703C15.9024 8.31651 15.9024 7.68349 16.293 7.29297L17.293 6.29297Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 2C14.5523 2 15 2.44772 15 3C15 3.55228 14.5523 4 14 4H10C9.44772 4 9 3.55228 9 3C9 2.44772 9.44772 2 10 2H14Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10_2"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStopwatch);
export default __webpack_public_path__ + "static/media/stopwatch.d6bf7f22abb1384c7b508eb138c1fc9c.svg";
export { ForwardRef as ReactComponent };